import { Box, Flex } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { DocumentoItem } from "core/features/documentos/typings";
import colors from "core/resources/theme/colors";
import moment from "moment";
import DocumentoIcone from "../DocumentoIcone";
import KebabMenu from "../KebabMenu";
import { useToast } from "@chakra-ui/react";

interface DocumentoProps {
  documento: DocumentoItem;
  onEdit?: (id: string) => any;
  onDelete?: (id: string) => any;
}

function Documento({ documento, onEdit, onDelete }: DocumentoProps) {
  const toast = useToast();

  return (
    <Flex
      bg={colors.white}
      rounded={16}
      p="16px"
      gap={"32px"}
      alignItems="center"
    >
      <Box w="60px">
        <DocumentoIcone mimetype={documento.mimetype} />
      </Box>
      <Flex flex={1} alignItems="center">
        <Text>{documento.nome}</Text>
      </Flex>
      <Box w="200px">
        <Text color={colors.blueishGray} lineHeight="12px">
          PARA QUEM
        </Text>
        <Text>{documento.destino}</Text>
      </Box>
      <Box w="100px">
        <Text color={colors.blueishGray} lineHeight="12px">
          POSTADO EM
        </Text>
        <Text>{moment(documento.createdAt).format("DD/MM/YYYY")}</Text>
      </Box>

      <Flex justifyContent="flex-end">
        <KebabMenu
          onEdit={() => onEdit?.(documento.id)}
          onDelete={() => onDelete?.(documento.id)}
          extraActions={
            documento.referencia
              ? [
                  documento.mimetype?.startsWith("image") ||
                  documento.mimetype?.includes("pdf")
                    ? {
                        label: "Abrir",
                        onClick: () =>
                          window.open(documento.referencia, "_blank"),
                      }
                    : {
                        label: "Baixar",
                        onClick: () => {
                          let tag = document.createElement("a");
                          tag.setAttribute("display", "none");
                          tag.href = documento.referencia!;
                          tag.download = documento.nome!;
                          document.body.appendChild(tag);
                          tag.click();
                          document.body.removeChild(tag);
                        },
                      },
                  {
                    label: "Copiar Link",
                    onClick: () => {
                      navigator.clipboard.writeText(documento.referencia!);
                        toast({
                          position: "top-right",
                          title: `Link copiado.`,

                          status: "success",
                          duration: 5000,
                          isClosable: true,
                        });
                    },
                  },
                ]
              : undefined
          }
        />
      </Flex>
    </Flex>
  );
}

export default Documento;
